/* eslint-disable camelcase */
import { Grid } from '@mui/material'
import AdministrationAction from 'administration/actions/AdministrationAction'
import Card from 'components/card/Card'
import Checkbox from 'components/forms/Checkbox'
import Input from 'components/forms/Input'
import NumberField from 'components/forms/NumberField'
import Select from 'components/forms/Select'
import ProgressCard from 'components/card/ProgressCard'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'
import DtoAgriTanksType from 'exploitations/dto/DtoAgriTanksType'
import { DEPARTEMENT_TAG } from 'installation/constants/InstallationConstants'
import { template } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import useActions from 'utils/customHook/useActions'
import useSandreList from 'utils/customHook/useSandreList'
import useTitle from 'utils/customHook/useTitle'
import { isTrue } from 'utils/SettingUtils'
import useStateAppSetting from 'utils/customHook/useStateAppSetting'

const ExploitationsSettingsApp = ({

}) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [readMode, setReadMode] = useState(true)

    const {
        applicationSettings,
        agriTanksTypes,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
        agriTanksTypes: store.AgriReducer.agriTanksTypes,
    }), shallowEqual)

    const dispatch = useDispatch()

    const isValidLength = (length) => {
        return length && length > 0 && length !== '0' && length !== 'null' && length !== 'undefined'
    }

    const [useAutomaticCodificationExploitation, setUseAutomaticCodificationExploitation, onCancelUseAutomaticCodificationExploitation] = useStateAppSetting('useAutomaticCodificationExploitation')
    const [prefixCodificationExploitation, setPrefixCodificationExploitation, onCancelPrefixCodificationExploitation] = useStateAppSetting('prefixCodificationExploitation')
    const [suffixCodificationExploitation, setSuffixCodificationExploitation, onCancelSuffixCodificationExploitation] = useStateAppSetting('suffixCodificationExploitation')
    const [minLengthCodificationExploitation, setMinLengthCodificationExploitation, onCancelMinLengthCodificationExploitation] = useStateAppSetting('minLengthCodificationExploitation', setting => isValidLength(setting) ? setting : 4)
    const [useAutomaticCodificationInstallation, setUseAutomaticCodificationInstallation, onCancelUseAutomaticCodificationInstallation] = useStateAppSetting('useAutomaticCodificationInstallation')
    const [prefixCodificationInstallation, setPrefixCodificationInstallation, onCancelPrefixCodificationInstallation] = useStateAppSetting('prefixCodificationInstallation')
    const [suffixCodificationInstallation, setSuffixCodificationInstallation, onCancelSuffixCodificationInstallation] = useStateAppSetting('suffixCodificationInstallation')
    const [minLengthCodificationInstallation, setMinLengthCodificationInstallation, onCancelMinLengthCodificationInstallation] = useStateAppSetting('minLengthCodificationInstallation', setting => isValidLength(setting) ? setting : 4)
    const [defaultDepartmentCodificationInstallation, setDefaultDepartmentCodificationInstallation, onCancelDefaultDepartmentCodificationInstallation] = useStateAppSetting('defaultDepartmentCodificationInstallation')
    const [useAutomaticCodificationTank, setUseAutomaticCodificationTank, onCancelUseAutomaticCodificationTank] = useStateAppSetting('useAutomaticCodificationTank')
    const [blockEntryTankProperties, setBlockEntryTankProperties, onCancelBlockEntryTankProperties] = useStateAppSetting('blockEntryTankProperties')
    const [prefixCodificationTank, setPrefixCodificationTank, onCancelPrefixCodificationTank] = useStateAppSetting('prefixCodificationTank')
    const [suffixCodificationTank, setSuffixCodificationTank, onCancelSuffixCodificationTank] = useStateAppSetting('suffixCodificationTank')
    const [minLengthCodificationTank, setMinLengthCodificationTank, onCancelMinLengthCodificationTank] = useStateAppSetting('minLengthCodificationTank', setting => isValidLength(setting) ? setting : 4)
    const [defaultTankType, setDefaultTankType, onCancelDefaultTankType] = useStateAppSetting('defaultTankType')
    const [minVolumeEligibilityTank, setMinVolumeEligibilityTank, onCancelMinVolumeEligibilityTank] = useStateAppSetting('minVolumeEligibilityTank', () => {}, 2000)
    const [materielReadingCoeffEntry, setMaterielReadingCoeffEntry, onCancelMaterielReadingCoeffEntry] = useStateAppSetting('materielReadingCoeffEntry')
    const [useAutomaticCodificationPump, setUseAutomaticCodificationPump, onCancelUseAutomaticCodificationPump] = useStateAppSetting('useAutomaticCodificationPump')
    const [blockEntryPumpProperties, setBlockEntryPumpProperties, onCancelBlockEntryPumpProperties] = useStateAppSetting('blockEntryPumpProperties')
    const [prefixCodificationPump, setPrefixCodificationPump, onCancelPrefixCodificationPump] = useStateAppSetting('prefixCodificationPump')
    const [suffixCodificationPump, setSuffixCodificationPump, onCancelSuffixCodificationPump] = useStateAppSetting('suffixCodificationPump')
    const [minLengthCodificationPump, setMinLengthCodificationPump, onCancelMinLengthCodificationPump] = useStateAppSetting('minLengthCodificationPump', setting => isValidLength(setting) ? setting : 4)
    const [useAutomaticCodificationCounter, setUseAutomaticCodificationCounter, onCancelUseAutomaticCodificationCounter] = useStateAppSetting('useAutomaticCodificationCounter')
    const [authorizedCreationCounter, setAuthorizedCreationCounter, onCancelAuthorizedCreationCounter] = useStateAppSetting('authorizedCreationCounter')
    const [blockEntryCounterProperties, setBlockEntryCounterProperties, onCancelBlockEntryCounterProperties] = useStateAppSetting('blockEntryCounterProperties')
    const [prefixCodificationCounter, setPrefixCodificationCounter, onCancelPrefixCodificationCounter] = useStateAppSetting('prefixCodificationCounter')
    const [suffixCodificationCounter, setSuffixCodificationCounter, onCancelSuffixCodificationCounter] = useStateAppSetting('suffixCodificationCounter')
    const [minLengthCodificationCounter, setMinLengthCodificationCounter, onCancelMinLengthCodificationCounter] = useStateAppSetting('minLengthCodificationCounter', setting => isValidLength(setting) ? setting : 4)

    const [agriChamber, setAgriChamber] = useStateAppSetting('chambreAgri', () => {}, 'CAXX')
    const [orderNumber, setOrderNumber] = useStateAppSetting('numeroCommande', () => {}, 'OUGC_XX_2022')
    const [servicesLogin, setServicesLogin] = useStateAppSetting('loginOCTAGRI')
    const [codification, setCodification] = useStateAppSetting('codificationOCTAGRI')

    useEffect(() => {
        if (!applicationSettings.length) {
            dispatch(AdministrationAction.fetchApplicationSettings()).then(setDataLoaded(true))
        } else {
            setDataLoaded(true)
        }
    }, [])

    useTitle(() => [{
        title: i18n.folders,
        href: 'dossiers',
    }, {
        title: i18n.settings,
        href: 'dossiers/settings',
    }, {
        title: i18n.parameters,
        href: 'dossiers/settings/parameters',
    }], [])

    const codif = useSandreList(SANDRE.INTERVENANTS_TYPE_CODIFICATION)

    const onSave = () => {
        const settings = [
            { parameter: 'useAutomaticCodificationExploitation', value: useAutomaticCodificationExploitation },
            { parameter: 'prefixCodificationExploitation', value: prefixCodificationExploitation },
            { parameter: 'suffixCodificationExploitation', value: suffixCodificationExploitation },
            { parameter: 'minLengthCodificationExploitation', value: isValidLength(minLengthCodificationExploitation) ? String(minLengthCodificationExploitation) : '4' },

            { parameter: 'useAutomaticCodificationInstallation', value: useAutomaticCodificationInstallation },
            { parameter: 'prefixCodificationInstallation', value: prefixCodificationInstallation },
            { parameter: 'suffixCodificationInstallation', value: suffixCodificationInstallation },
            { parameter: 'minLengthCodificationInstallation', value: isValidLength(minLengthCodificationInstallation) ? String(minLengthCodificationInstallation) : '4' },
            { parameter: 'defaultDepartmentCodificationInstallation', value: defaultDepartmentCodificationInstallation },

            { parameter: 'useAutomaticCodificationTank', value: useAutomaticCodificationTank },
            { parameter: 'blockEntryTankProperties', value: blockEntryTankProperties },
            { parameter: 'prefixCodificationTank', value: prefixCodificationTank },
            { parameter: 'suffixCodificationTank', value: suffixCodificationTank },
            { parameter: 'minLengthCodificationTank', value: isValidLength(minLengthCodificationTank) ? String(minLengthCodificationTank) : '4' },
            { parameter: 'defaultTankType', value: defaultTankType ? String(defaultTankType) : null },
            { parameter: 'minVolumeEligibilityTank', value: minVolumeEligibilityTank ? String(minVolumeEligibilityTank) : null },

            { parameter: 'materielReadingCoeffEntry', value: materielReadingCoeffEntry },

            { parameter: 'useAutomaticCodificationPump', value: useAutomaticCodificationPump },
            { parameter: 'blockEntryPumpProperties', value: blockEntryPumpProperties },
            { parameter: 'prefixCodificationPump', value: prefixCodificationPump },
            { parameter: 'suffixCodificationPump', value: suffixCodificationPump },
            { parameter: 'minLengthCodificationPump', value: isValidLength(minLengthCodificationPump) ? String(minLengthCodificationPump) : '4' },

            { parameter: 'useAutomaticCodificationCounter', value: useAutomaticCodificationCounter },
            { parameter: 'authorizedCreationCounter', value: authorizedCreationCounter },
            { parameter: 'blockEntryCounterProperties', value: blockEntryCounterProperties },
            { parameter: 'prefixCodificationCounter', value: prefixCodificationCounter },
            { parameter: 'suffixCodificationCounter', value: suffixCodificationCounter },
            { parameter: 'minLengthCodificationCounter', value: isValidLength(minLengthCodificationCounter) ? String(minLengthCodificationCounter) : '4' },

            { parameter: 'chambreAgri', value: agriChamber },
            { parameter: 'numeroCommande', value: orderNumber },
            { parameter: 'loginOCTAGRI', value: servicesLogin },
            { parameter: 'codificationOCTAGRI', value: codification },
        ]
        setDataLoaded(false)
        dispatch(AdministrationAction.updateSieauParameters(settings)).then(() => {
            dispatch(AdministrationAction.fetchApplicationSettings()).then(() => {
                setReadMode(true)
                setDataLoaded(true)
            })
        })
    }

    const onCancelAll = () => {
        onCancelUseAutomaticCodificationExploitation()
        onCancelPrefixCodificationExploitation()
        onCancelSuffixCodificationExploitation()
        onCancelMinLengthCodificationExploitation()
        onCancelUseAutomaticCodificationInstallation()
        onCancelPrefixCodificationInstallation()
        onCancelSuffixCodificationInstallation()
        onCancelMinLengthCodificationInstallation()
        onCancelDefaultDepartmentCodificationInstallation()
        onCancelUseAutomaticCodificationTank()
        onCancelBlockEntryTankProperties()
        onCancelPrefixCodificationTank()
        onCancelSuffixCodificationTank()
        onCancelMinLengthCodificationTank()
        onCancelDefaultTankType()
        onCancelMinVolumeEligibilityTank()
        onCancelMaterielReadingCoeffEntry()
        onCancelUseAutomaticCodificationPump()
        onCancelBlockEntryPumpProperties()
        onCancelPrefixCodificationPump()
        onCancelSuffixCodificationPump()
        onCancelMinLengthCodificationPump()
        onCancelUseAutomaticCodificationCounter()
        onCancelAuthorizedCreationCounter()
        onCancelBlockEntryCounterProperties()
        onCancelPrefixCodificationCounter()
        onCancelSuffixCodificationCounter()
        onCancelMinLengthCodificationCounter()
    }

    useActions(() => {
        return readMode ? {
            edit: () => setReadMode(false),
        } : {
            save: onSave,
            cancel: () => {
                onCancelAll()
                setReadMode(true)
            },
        }
    }, [readMode, useAutomaticCodificationExploitation, prefixCodificationExploitation, suffixCodificationExploitation, minLengthCodificationExploitation, useAutomaticCodificationInstallation,
        prefixCodificationInstallation, suffixCodificationInstallation, minLengthCodificationInstallation, defaultDepartmentCodificationInstallation, useAutomaticCodificationTank, blockEntryTankProperties, prefixCodificationTank,
        suffixCodificationTank, minLengthCodificationTank, defaultTankType, minVolumeEligibilityTank, materielReadingCoeffEntry, useAutomaticCodificationPump, blockEntryPumpProperties, prefixCodificationPump, suffixCodificationPump,
        minLengthCodificationPump, useAutomaticCodificationCounter, authorizedCreationCounter, blockEntryCounterProperties, prefixCodificationCounter, suffixCodificationCounter, minLengthCodificationCounter, applicationSettings, agriChamber,
        orderNumber, servicesLogin, codification,
    ])

    const getCodification = () => {
        const prefixFormatted = prefixCodificationInstallation && prefixCodificationInstallation.includes(DEPARTEMENT_TAG) ? prefixCodificationInstallation.replace(DEPARTEMENT_TAG, defaultDepartmentCodificationInstallation || '') : prefixCodificationInstallation
        return `${prefixFormatted || ''}${'0'.repeat((minLengthCodificationInstallation || 4) - 1)}1${suffixCodificationInstallation || ''}`
    }

    if (!dataLoaded) return <ProgressCard withMessage indeterminate round />
    return (
        <Card title={i18n.settings} round>
            <div className='padding-left-1 padding-right-1 padding-bottom-1'>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.exploitation}</StyledLegend>
                    <Grid container spacing={1}>
                        <Grid size={12} className='margin-bottom-1'>
                            <Checkbox
                                label={i18n.autoCodification}
                                checked={isTrue(useAutomaticCodificationExploitation)}
                                onChange={(v) => setUseAutomaticCodificationExploitation(v ? '1' : '0')}
                                disabled={readMode}
                            />
                        </Grid>
                        {isTrue(useAutomaticCodificationExploitation) && (
                            <>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.prefix}
                                        value={prefixCodificationExploitation}
                                        onChange={setPrefixCodificationExploitation}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.suffix}
                                        value={suffixCodificationExploitation}
                                        onChange={setSuffixCodificationExploitation}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <NumberField
                                        title={i18n.minIdLength}
                                        value={minLengthCodificationExploitation}
                                        onChange={setMinLengthCodificationExploitation}
                                        disabled={readMode}
                                        min={1}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <p className='italic-label'>{i18n.result}: {prefixCodificationExploitation}{'0'.repeat((minLengthCodificationExploitation || 4) - 1)}1{suffixCodificationExploitation}</p>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </StyledFieldSet>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.pointPrelevement}</StyledLegend>
                    <Grid container spacing={1}>
                        <Grid size={12} className='margin-bottom-1'>
                            <Checkbox
                                label={i18n.autoCodification}
                                checked={isTrue(useAutomaticCodificationInstallation)}
                                onChange={v => setUseAutomaticCodificationInstallation(v ? '1' : '0')}
                                disabled={readMode}
                            />
                        </Grid>
                        {isTrue(useAutomaticCodificationInstallation) && (
                            <>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.prefix}
                                        value={prefixCodificationInstallation}
                                        onChange={setPrefixCodificationInstallation}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.suffix}
                                        value={suffixCodificationInstallation}
                                        onChange={setSuffixCodificationInstallation}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <NumberField
                                        title={i18n.minIdLength}
                                        value={minLengthCodificationInstallation}
                                        onChange={setMinLengthCodificationInstallation}
                                        disabled={readMode}
                                        min={1}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.defaultDepartmentNum}
                                        value={defaultDepartmentCodificationInstallation}
                                        onChange={setDefaultDepartmentCodificationInstallation}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <p className='italic-label'>{template(i18n.useDepartmentTag)({ tag: DEPARTEMENT_TAG })}</p>
                                </Grid>
                                <Grid size={12}>
                                    <p className='italic-label'>{i18n.result}: {getCodification}</p>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </StyledFieldSet>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.detention}</StyledLegend>
                    <Grid container spacing={1}>
                        <Grid container size={12} spacing={2} className='margin-bottom-1'>
                            <Checkbox
                                label={i18n.autoCodification}
                                checked={isTrue(useAutomaticCodificationTank)}
                                onChange={v => setUseAutomaticCodificationTank(v ? '1' : '0')}
                                disabled={readMode}
                            />
                            <Checkbox
                                label={i18n.blockEntryTankProperties}
                                checked={isTrue(blockEntryTankProperties)}
                                onChange={v => setBlockEntryTankProperties(v ? '1' : '0')}
                                disabled={readMode}
                            />
                        </Grid>
                        {isTrue(useAutomaticCodificationTank) && (
                            <>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.prefix}
                                        value={prefixCodificationTank}
                                        onChange={setPrefixCodificationTank}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.suffix}
                                        value={suffixCodificationTank}
                                        onChange={setSuffixCodificationTank}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <NumberField
                                        title={i18n.minIdLength}
                                        value={minLengthCodificationTank}
                                        onChange={setMinLengthCodificationTank}
                                        disabled={readMode}
                                        min={1}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <p className='italic-label'>{i18n.result}: {prefixCodificationTank}{'0'.repeat((minLengthCodificationTank || 4) - 1)}1{suffixCodificationTank}</p>
                                </Grid>
                            </>
                        )}
                        <Grid size={4}>
                            <Select
                                label={i18n.detentionTypeByDefault}
                                value={defaultTankType}
                                options={agriTanksTypes}
                                keyValue='id'
                                keyLabel='name'
                                onChange={v => setDefaultTankType(v || null)}
                                disabled={readMode}
                            />
                        </Grid>
                        <Grid size={4}>
                            <NumberField
                                title={i18n.minVolumeEligibility}
                                value={minVolumeEligibilityTank}
                                onChange={setMinVolumeEligibilityTank}
                                disabled={readMode}
                                min={0}
                            />
                        </Grid>
                    </Grid>
                </StyledFieldSet>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.pumpingEquipments}</StyledLegend>
                    <Grid container spacing={1}>
                        <Grid container size={12} spacing={2} className='margin-bottom-1'>
                            <Checkbox
                                label={i18n.autoCodification}
                                checked={isTrue(useAutomaticCodificationPump)}
                                onChange={v => {
                                    setUseAutomaticCodificationPump(v ? '1' : '0')
                                    if (!v) {
                                        setAuthorizedCreationCounter('0')
                                    }
                                }}
                                disabled={readMode}
                            />
                            <Checkbox
                                label={i18n.blockEntryPumpProperties}
                                checked={isTrue(blockEntryPumpProperties)}
                                onChange={v => setBlockEntryPumpProperties(v ? '1' : '0')}
                                disabled={readMode}
                            />
                        </Grid>
                        {isTrue(useAutomaticCodificationPump) && (
                            <>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.prefix}
                                        value={prefixCodificationPump}
                                        onChange={setPrefixCodificationPump}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.suffix}
                                        value={suffixCodificationPump}
                                        onChange={setSuffixCodificationPump}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <NumberField
                                        title={i18n.minIdLength}
                                        value={minLengthCodificationPump}
                                        onChange={setMinLengthCodificationPump}
                                        disabled={readMode}
                                        min={1}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <p className='italic-label'>{i18n.result}: {prefixCodificationPump}{'0'.repeat((minLengthCodificationPump || 4) - 1)}1{suffixCodificationPump}</p>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </StyledFieldSet>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.countingDevices}</StyledLegend>
                    <Grid container size={12} spacing={1}>
                        <Grid container size={12} spacing={2} className='margin-bottom-1'>
                            <Checkbox
                                label={i18n.autoCodification}
                                checked={isTrue(useAutomaticCodificationCounter)}
                                onChange={v => {
                                    setUseAutomaticCodificationCounter(v ? '1' : '0')
                                    if (!v) {
                                        setAuthorizedCreationCounter('0')
                                    }
                                }}
                                disabled={readMode}
                            />
                            <Checkbox
                                label={i18n.authorizedCreationCounter}
                                checked={isTrue(authorizedCreationCounter)}
                                onChange={v => setAuthorizedCreationCounter(v ? '1' : '0')}
                                disabled={readMode || !isTrue(useAutomaticCodificationCounter) || !isTrue(useAutomaticCodificationPump)}
                            />
                            <Checkbox
                                label={i18n.blockEntryCounterProperties}
                                checked={isTrue(blockEntryCounterProperties)}
                                onChange={v => setBlockEntryCounterProperties(v ? '1' : '0')}
                                disabled={readMode}
                            />
                        </Grid>
                        {isTrue(useAutomaticCodificationCounter) && (
                            <>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.prefix}
                                        value={prefixCodificationCounter}
                                        onChange={setPrefixCodificationCounter}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Input
                                        title={i18n.suffix}
                                        value={suffixCodificationCounter}
                                        onChange={setSuffixCodificationCounter}
                                        disabled={readMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <NumberField
                                        title={i18n.minIdLength}
                                        value={minLengthCodificationCounter}
                                        onChange={setMinLengthCodificationCounter}
                                        disabled={readMode}
                                        min={1}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <p className='italic-label'>{i18n.result}: {prefixCodificationCounter}{'0'.repeat((minLengthCodificationCounter || 4) - 1)}1{suffixCodificationCounter}</p>
                                </Grid>
                            </>
                        )}
                        <Grid>
                            <Select
                                label={i18n.readingCoefficient}
                                value={materielReadingCoeffEntry}
                                options={[
                                    { value: '1', label: i18n.oneOrTen },
                                ]}
                                keyValue='code'
                                onChange={v => setMaterielReadingCoeffEntry(v || null)}
                                disabled={readMode}
                                nullLabel={i18n.freeEntry}
                            />
                        </Grid>
                    </Grid>
                </StyledFieldSet>
                <StyledFieldSet className='margin-1'>
                    <StyledLegend>{i18n.servicesExport}</StyledLegend>
                    <Grid container spacing={2}>
                        <Grid size={4}>
                            <Select
                                label={i18n.codification}
                                options={codif}
                                value={codification}
                                onChange={setCodification}
                                obligatory
                                disabled={readMode}
                                stringValue
                            />
                        </Grid>
                        <Grid size={4}>
                            <Input
                                title={i18n.agriChamber}
                                value={agriChamber}
                                onChange={setAgriChamber}
                                disabled={readMode}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Input
                                title={i18n.orderNumber}
                                value={orderNumber}
                                onChange={setOrderNumber}
                                disabled={readMode}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Input
                                title={i18n.servicesLogin}
                                value={servicesLogin}
                                onChange={setServicesLogin}
                                disabled={readMode}
                            />
                        </Grid>
                    </Grid>
                </StyledFieldSet>
            </div>
        </Card>
    )
}

ExploitationsSettingsApp.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
    agriTanksTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoAgriTanksType)),
}

export default ExploitationsSettingsApp